import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { RequiredConfigurationService } from '../services/required-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class RequiredConfigurationLoadedGuard implements CanLoad, CanActivate, CanActivateChild {
  private readonly loginUrl: UrlTree;

  constructor(
    private requiredConfigurationService: RequiredConfigurationService,
    private router: Router,
  ) {
    this.loginUrl = this.router.parseUrl('login');
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.requiredConfigurationLoaded();
  }

  canActivateChild(): Observable<boolean | UrlTree> {
    return this.requiredConfigurationLoaded();
  }

  canLoad(): Observable<boolean | UrlTree> {
    return this.requiredConfigurationLoaded();
  }

  private requiredConfigurationLoaded(): Observable<boolean | UrlTree> {
    return this.requiredConfigurationService.configurations$.pipe(
      first(),
      map((configurations) => {
        for (const configuration of configurations) {
          if (configuration == null) {
            return this.loginUrl;
          }
        }
        return true;
      }),
    );
  }
}
